import { AssigneeList } from '@src/features/participants/pages/detail/components/participant-progress/assignee-list';
import universitiesApi from '../../services/universities-api';
import type { TSubmission } from '@src/shared/types/submission';

const UniversityAssigneeListCell = ({
  submission,
}: {
  submission: TSubmission;
}) => {
  const { mutateAsync: updateUniversity } = universitiesApi.useUpdate();

  return (
    <AssigneeList
      submission={submission}
      showTrigger={false}
      useMemberId
      onSelect={(newAssigneeId) => {
        if (submission.id) {
          updateUniversity({
            id: submission.id,
            manager_member: newAssigneeId ? Number(newAssigneeId) : null,
          });
        }
      }}
    />
  );
};

export default UniversityAssigneeListCell;
